<template>
  <div class="display-box" >
    <draggable
      :group="{ name: 'module', put: true }"
      @add="addModule"
      @update="sortModule"
      :value="selectedModules"
      animation="300"
      ghostClass="selected-modules-ghost"
      class="home-drag"
      scroll
    >
      <div
        class="selected-modules"
        v-for="(item, index) in selectedModules"
        :key="item.id"
      >
        <!-- {{item.name}} -->
        <img :src="`${baseUrl}images/${item.code}.jpg`" alt="" class="home-module-img">
        <i class="el-icon-error" @click="removeModules(item, index)"></i>
      </div>
    </draggable>
    <div v-if="selectedModules.length==0" class="prompt">请先添加左侧模块</div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import Banner from "@/components/office/Banner";
import CARD from "@/components/office/CARD";
import TOPIC from "@/components/office/TOPIC";
import TOPICDL from "@/components/office/TOPICDL";
import SUBJECT from "@/components/office/SUBJECT";
import SUBJECTDL from "@/components/office/SUBJECTDL";
import COMMENT from "@/components/office/COMMENT";
import LINK from "@/components/office/LINK";

export default {
  name: "card",
  components: { draggable, Banner, CARD, TOPIC, TOPICDL, SUBJECT, SUBJECTDL, COMMENT, LINK },
  props: ["childModules"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      selectedModules: [],
      displayModuleList: [],
    };
  },
  created() {
    this.defualtSelectedModules()
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  methods: {
    addModule(e) {
      let targetIndex = e.newIndex;
      let childModulesIndex = e.oldIndex;
      let childModule = this.childModules[childModulesIndex];
      // 判断添加的模块是否存在
      const exist = this.selectedModules.some((item) => {
        return item.id === childModule.id;
      })
      if(exist){
        this.$message.warning('不能重复添加已添加的模块')
        return
      }
      this.selectedModules.splice(targetIndex, 0, childModule);
      this.$emit('caseChanged', true)
    },
    addButton(data){
      // 判断添加的模块是否存在
      const exist = this.selectedModules.some((item) => {
        return item.id === data.id;
      })
      if(exist){
        this.$message.warning('不能重复添加已添加的模块')
        return
      }
      this.selectedModules.push(data);
      this.$emit('caseChanged', true)
    },
    sortModule(e) {
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let selectedModule = this.selectedModules[oldIndex];
      this.selectedModules.splice(oldIndex, 1);
      this.selectedModules.splice(newIndex, 0, selectedModule);
      this.$emit('caseChanged', true)
    },
    removeModules(item, index){
      this.selectedModules.splice(index, 1);
      this.$emit('caseChanged', true)
    },
    isEmpty(){
      return this.selectedModules.length ? false : true
    },
    defualtSelectedModules(){
      this.moduleList.forEach(item => {
        this.childModules.forEach(element => {
          if(item.cardType===element.code){
            this.selectedModules.push(element)
          }
        });
      });
    },
  },
  watch: {
    selectedModules(val){
      this.$emit('selectedChange', {data:val, module: 'home'})
      val.forEach((item) => {
        this.moduleList.forEach((e) => {
          if(e.cardType===item.code){
            this.displayModuleList.push(e)
          }
        })
      })
    },
  },
  filters: {},
};
</script>

<style lang="less">
.home-drag {
  position: relative;
  min-height: 500px;
  .selected-modules:hover .el-icon-error {
    display: block !important;
  }
  .home-module-img {
    width: 100%;
    height: auto;
  }
}
</style>